import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, finalize, tap, timeout } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private activeRequests = 0;
  private readonly REQUEST_TIMEOUT = 25000; // 25 secondi

  constructor(private spinner: NgxSpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Incrementa il contatore e mostra lo spinner
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.spinner.show();
    }

    return next.handle(req).pipe(
      // Timeout della richiesta HTTP
      timeout(this.REQUEST_TIMEOUT),

      // Gestione degli eventi HTTP
      tap(
        event => {
          // Opzionale: puoi gestire eventi specifici qui
          if (event instanceof HttpResponse) {
            // console.log('Risposta HTTP ricevuta');
          }
        }
      ),

      // Gestione degli errori
      catchError((error: any) => {
        if (error instanceof TimeoutError) {
          console.error(`Timeout della richiesta HTTP dopo ${this.REQUEST_TIMEOUT / 1000} secondi`);
          // Puoi mostrare un messaggio di errore all'utente qui
        } else if (error instanceof HttpErrorResponse) {
          console.error('Errore HTTP:', error.status, error.message);
        }
        return throwError(error);
      }),

      // Sempre eseguito alla fine (sia in caso di successo che errore)
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.spinner.hide();
        }
      })
    );
  }
}
